import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 3l-11 11","key":"svg-0"}],["path",{"d":"M3 10v4h4","key":"svg-1"}],["path",{"d":"M17 10h4v4","key":"svg-2"}],["path",{"d":"M10 21l11 -11","key":"svg-3"}]]

const IconArrowsDoubleSwNe = createReactComponent('outline', 'arrows-double-sw-ne', 'ArrowsDoubleSwNe', __iconNode);

export default IconArrowsDoubleSwNe;